<!--- start here-->
<div>
  <div>
    <div class="row">
      <div class="col-12 mb-3">
          <div class="cd-title">
            <div class="row g-0">
              <div class="col-10">Detail Produk</div>
              <div class="col-2 text-end">
                <app-share *ngIf="shareData" shareType="product" shareData="{{shareData | json}}" shareDetail="{{'' | json}}"  shareTitle="{{shareTitle}}" shareUrl="{{shareUrl}}"></app-share>
              </div>
            </div>
          </div>
      </div>   
    </div>

    <div class="card border-0" *ngIf="!compareData">
      <div class="cd-content p-3 p-lg-4">
        <div class="row">
          <div class="col-lg-4 mb-3"  [style.opacity]="isLogin  ? '1' : '0.1'">

                  <div class="">
                    <lightgallery [settings]="settingsGallery" [onInit]="onInitGallery" id="shopsideGallery" class="row g-0">
                      <div class="{{itemsGallery.length>1 ? 'col-9':'col-12'}}">
                        <ng-container *ngFor="let item of itemsGallery; let i = index">
                          <a *ngIf="i==0" class="text-center itemz image-box" [attr.href]="item">
                            <img class="img-fluid p-1 " src="{{ item }}" />
                          </a>
                        </ng-container>
                        
                      </div>
                      <div class="col-3">
                        <div class="row g-0">
                          <ng-container *ngFor="let item of itemsGallery; let i = index">
                            <div class="col-12">
                              <a *ngIf="i!==0" class="text-center itemz image-box" [attr.href]="item">
                                <img class="img-fluid p-1 " src="{{ item }}" />
                              </a>
                            </div>
                          </ng-container>
                        </div>
                      </div>

                    </lightgallery>
                  </div>


            <!-- <div class="row">
              <div class="col-9">
                img 1
              </div>
              <div class="col-3">
                <div class="row">
                  <div class="col-12">
                    img 2
                  </div>
                  <div class="col-12">
                    img 3
                  </div>
                  <div class="col-12">
                    img 4
                  </div>
                </div>
              </div>   
            </div> -->
    
          </div>

          <div class="col-lg-8 mb-3"  [style.opacity]="isLogin ? '1' : '0.1'">
            <div class="row">
              <div class="col-12 mb-2">
                <h3 class="cdc1 fw-bold">{{productData?.name}}</h3>
              </div>

              <div class="col-12" [hidden]="!productData?.isDisplayPriceOnShopfront">
                <div class="text-end cd-title cdbgthird mb-3" [hidden]="!isLogin">
                  <h2 class="mb-0 cdc1 fw-bold">{{productData?.currency}} {{productData?.price | number}}</h2>
                </div>
              </div>

              <div class="col-12 mb-2" *ngIf="companyData">

                                        <table class="mb-2 mb-sm-4">
                                          <tr>
                                              <td>
                                                <img  class="rounded-circle avatar" src="{{(companyData?.vendorLogo)?companyData?.vendorLogo:'/assets/images/default-company.jpeg'}}" style="width: 40px; height: 40px;">
                                                
                                              </td>
                                              <td>
                                                <!-- <strong class="ms-2 me-2">{{companyName}}</strong> -->

                                                <span *ngIf="companyData?.vendorName" class="ps-2 cdc1 fw-bold pointer" (click)="redirect()">
                                                  <!-- <img src="/assets/images/icons/vendor-icon.png" class="vendor-icon pe-1"> -->
                                                  <font class="limit-text">{{ companyData?.vendorName }}</font>
                                                </span>
                                                <span *ngIf="!companyData?.vendorName"
                                                  class="ms-2 badge rounded-pill cdbg1 text-white ncpname text-dark limit-text badge-limit"
                                                  >
                                                  <!-- <img src="/assets/images/icons/vendor-confidential.png" class="vendor-icon pe-1"> -->
                                                  <font class="limit-text">Confidential</font>
                                                </span>

                                                <br>
                                                <div *ngIf="companyData?.vendorName" class="vendorLoc ps-1">
                                                  <small class="cdc1"><i class="bi bi-geo-alt-fill" style="color:var(--primary-color)"></i> {{companyData?.vendorLocation}} &nbsp;&nbsp;
                                                    
                                                    <ng-container *ngIf="companyData?.isCompanySetPKP">
                                                      |&nbsp;&nbsp; Tax Status:  {{(companyData?.isPKP)?'PKP':'non-PKP'}}
                                                    </ng-container>
                                                  </small>
                                                </div>


                                              </td> 
                                              <td>
                                              <!-- <img src="/assets/images/icons/fluent_ribbon-star-24-filled@3x.png" class="img-fluid ratingiconsmall">
                                              <img src="/assets/images/icons/fluent_ribbon-star-24-filled@3x.png" class="img-fluid ratingiconsmall"> -->
                                              </td>
                                          </tr>
                                        </table>
    
                                        <div class="col-12 mt-3 pt-1 d-none">
                                            <div class="row text-center mb-3">
                                              <div class="col text-center">
                                                  <div class="boxratingtitle">Customer Satisfaction</div>
                                                  <div class="boxrating pt-4 pb-4">
                                                      <img src="/assets/images/icons/fluent_ribbon-star-24-filled@3x.png" class="img-fluid ratingiconsmall">
                                                      <img src="/assets/images/icons/fluent_ribbon-star-24-filled@3x.png" class="img-fluid ratingiconsmall">
                                                      <!-- <img src="/assets/images/icons/fluent_ribbon-star-24-filled@3x.png" class="img-fluid ratingicon">
                                                      <img src="/assets/images/icons/fluent_ribbon-star-24-filled@3x.png" class="img-fluid ratingicon">
                                                      <img src="/assets/images/icons/fluent_ribbon-star-24-filled@3x.png" class="img-fluid ratingicon"> -->
                                                  </div>
                                              </div>
                                              <div class="col text-center">
                                                      <div class="boxratingtitle">Product Rating</div>
                                                      <div class="boxrating pt-3 pb-3">
                                                          <h1 class="fw-bold fw-bold mb-1 mt-1 boxratingtext">4.8<img src="/assets/images/icons/rating-star.png" class="img-fluid starsmall"></h1>
                                                      </div>
                                              </div>
                                              <div class="col text-center">
                                                  <!-- <div class="boxratingtitle">Viewed Today</div>
                                                  <div class="boxrating pt-3 pb-3">
                                                      <h1 class="fw-bold fw-bold mb-1 mt-1">5<img src="/assets/images/icons/rating-down.png" class="img-fluid align-top pt-2"></h1>
                                                  </div> -->
                                              </div>
                                              <div class="col text-center">
                                                  <!-- <div class="boxratingtitle">Quoted Today</div>
                                                  <div class="boxrating pt-3 pb-3">
                                                      <h1 class="fw-bold fw-bold mb-1 mt-1">2<img src="/assets/images/icons/rating-up.png" class="img-fluid align-top pt-2"></h1>
                                                  </div> -->
                                              </div>
                                              <div class="col text-center">
                                                  <!-- <div class="boxratingtitle">On Auction Today</div>
                                                  <div class="boxrating pt-3 pb-3">
                                                      <h1 class="fw-bold fw-bold mb-1 mt-1">2<img src="/assets/images/icons/rating-up.png" class="img-fluid align-top pt-2"></h1>
                                                  </div> -->
                                              </div>
                                            </div>
                                        </div>
                                        

               
              </div>


              <div class="col-12 mb-2  d-none isHide" *ngIf="isPublic=='Y'">
                <div *ngIf="isPreviewShopFront=='N'">
                  <div class="text-end pt-3 pb-4" *ngIf="isLogin">
                    <a class="cart-btn mx-2" (click)="addToCart()">
                      <i class="bi bi-cart"></i>
                      Add to cart 
                    </a>

                    <a (click)="sendMessage()" class="ask-btn">
                      <img src="/assets/images/icons/qrfq-chat.jpg" class="ask-icon" /> Ask
                      Customer
                    </a>
                  </div>
                  <div class="text-end pt-3 pb-4" *ngIf="!isLogin">
                    <a class="cart-btn mx-2 disabled" style="cursor: not-allowed;">
                      <i class="bi bi-cart"></i>
                      Add to cart 
                    </a>

                    <a  class="ask-btn disabled" style="cursor: not-allowed;">
                      <img src="/assets/images/icons/qrfq-chat.jpg" class="ask-icon" /> Ask
                      Customer
                    </a>
                  </div>
                </div>
                <div *ngIf="isPreviewShopFront=='Y'">
                  <div class="text-end pt-3 pb-4">
                    <a class="cart-btn mx-2 disabled" style="cursor: not-allowed;">
                      <i class="bi bi-cart"></i>
                      Add to cart 
                    </a>

                    <a  class="ask-btn disabled" style="cursor: not-allowed;">
                      <img src="/assets/images/icons/qrfq-chat.jpg" class="ask-icon" /> Ask
                      Customer
                    </a>
                  </div>
                </div>
              </div>

 

              <div class="col-12 cd-rfq-product-quote" [hidden]="!isLogin">
                <div class="row">
                  <div class="col-lg-4">
                    <p class="mb-0">
                      <b>Merk Produk</b>
                    </p>
                    <p>{{productData?.brand ? productData?.brand : '-'}}</p>
                  </div>
                  <div class="col-lg-4">
                    <p class="mb-0">
                      <b>Kode Produk</b>
                    </p>
                    <p>{{productData?.sku ? productData?.sku : '-'}}</p>
                  </div>
                  <div class="col-lg-4">
                    <p class="mb-0">
                      <b>Nomor SKU</b>
                    </p>
                    
                    <p>{{productData?.manufacturerSku ? productData?.manufacturerSku : '-'}}</p>
                  </div>
                </div>
              </div>


         

            </div>
          </div>




          <div class="col-12" [hidden]="!isLogin">

              <div class="cd-rfq-product-quote">
                <div class="row">
                  <div class="col-lg-12">
                    <p class="mb-0">
                      <b>Company Tag</b>
                    </p>
                    <ng-container *ngIf="productData?.tags">
                      <p *ngIf="productData?.tags.length<1">-</p>
                      <div *ngIf="productData?.tags.length>0">
                        <span class="badge rounded-pill bg-secondary me-1 bgtags c1 badgetag" *ngFor="let tags of productData?.tags; let i = index">{{tags?.tag}}</span>
                      </div>
                    </ng-container>

                    <div class="pb-3"></div>
                  </div>
                  <div class="col-lg-12">
                    <p class="mb-0">
                      <b>Deskripsi Produk</b>
                    </p>
                    <div style="white-space: pre-line">{{divshotdesc(productData?.description)}}</div>
                    <div class="pb-3"></div>
                  </div>
                  <div class="col-lg-12">
                    <p class="mb-0">
                      <b>Label - Spesifikasi</b>
                    </p>
                    <ng-container *ngIf="divspec(productData?.description)">
                      <div [innerHtml]="divspec(productData?.description)"></div>
                    </ng-container>
                    <ng-container *ngIf="!divspec(productData?.description)">
                      -
                    </ng-container>
                    
                    <div class="pb-3"></div>
                  </div>
                </div>
              </div>            
          </div>



          <div class="col-12">
            <div class="row">
              <div class="col-12 cd-rfq-product-quote" *ngIf="isPublic=='N'">
                <div class="row g-3">
                  <div class="col-lg-6">
                    <div class="cdbgthird p-2">
                      <p class="mb-0">
                        <b>Harga Minimal</b>
                      </p>
                      <p class="mb-0" *ngIf="productData?.autobidMinimumPrice">{{productData?.currency}} {{productData?.autobidMinimumPrice | number}}</p>
                      <p class="mb-0" *ngIf="!productData?.autobidMinimumPrice">-</p>

                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="cdbgthird p-2">
                      <p class="mb-0">
                        <b>Kenaikan Diskon</b>
                      </p>
                      <p class="mb-0" *ngIf="productData?.autobidPriceDecrement">{{productData?.currency}} {{productData?.autobidPriceDecrement | number}}</p>
                      <p class="mb-0" *ngIf="!productData?.autobidPriceDecrement">-</p>
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <div class="cdbgthird p-2">
                      <p class="mb-0">
                        <b>Tampilkan Harga</b>
                      </p>

                      <span *ngIf='productData?.isDisplayPriceOnShopfront' class="badge rounded-pill ps-2 pe-2 pt-1 pb-1 bgenable">Enable</span>
                      <span *ngIf='!productData?.isDisplayPriceOnShopfront' class="badge rounded-pill ps-2 pe-2 pt-1 pb-1 bgdisable">Disable</span>    

                    </div>

           
                  </div>
                  <div class="col-lg-4">

                    <div class="cdbgthird p-2">
                      <p class="mb-0">
                        <b>Tampilkan di Shopfront</b>
                      </p>
                      <span *ngIf='productData?.isDisplayProductOnShopfront' class="badge rounded-pill ps-2 pe-2 pt-1 pb-1 bgenable">Enable</span>
                      <span *ngIf='!productData?.isDisplayProductOnShopfront' class="badge rounded-pill ps-2 pe-2 pt-1 pb-1 bgdisable">Disable</span>    

            

                    </div>

                
                  </div>


                  <div class="col-lg-4">

                    <div class="cdbgthird p-2">
                      <p class="mb-0">
                        <b>Auto Bid</b>
                      </p>

                        <span *ngIf='productData?.isAutobidEnabled' class="badge rounded-pill ps-2 pe-2 pt-1 pb-1 bgenable">Enable</span>
                        <span *ngIf='!productData?.isAutobidEnabled' class="badge rounded-pill ps-2 pe-2 pt-1 pb-1 bgdisable">Disable</span> 

                    </div>


                  </div>
                </div>
              </div>
            </div>
          </div>


          <div class="col position-absolute" *ngIf="isPublic=='Y'">
            <div class="" [hidden]="isLogin">
              <div class="notif p-5 text-center">
                <div class="py-5">
                  <p><strong>Please register to contact this seller.</strong></p>
                  <a href="/login" class="btn btn-primary bg1 fhbtn1t me-2 pointer"
                    >Login</a
                  >
                  or
                  <a href="/regis" class="btn btn-primary bg1 fhbtn1 ms-2 pointer"
                    >Register</a
                  >
                </div>

              </div>
            </div>
          </div>


        </div>
      </div>
    </div>

    
    <div class="card border-0" *ngIf="compareData">
      <div class="cd-content p-3 p-lg-4">
        <div class="row">



          <div class="col-lg-4 mb-3"  [style.opacity]="isLogin  ? '1' : '0.1'">

                  <div class="">
                    <lightgallery [settings]="settingsGallery" [onInit]="onInitGallery" id="shopsideGallery" class="row g-0">
                      <div class="{{itemsGallery.length>1 ? 'col-9':'col-12'}}">
                        <ng-container *ngFor="let item of itemsGallery; let i = index">
                          <a *ngIf="i==0" class="text-center itemz image-box" [attr.href]="item">
                            <img class="img-fluid p-1 {{compareData.existingProduct.imageUrl[i]!==compareData.draftProduct.draftImageUrl[i] ?'border-yellow':''}}" src="{{ item }}" />
                          </a> 
                        </ng-container>
                        
                      </div>
                      <div class="col-3">
                        <div class="row g-0">
                          <ng-container *ngFor="let item of itemsGallery; let i = index">
                            <div class="col-12">
                              <a *ngIf="i!==0" class="text-center itemz image-box" [attr.href]="item">
                                <img class="img-fluid p-1  {{compareData.existingProduct.imageUrl[i]!==compareData.draftProduct.draftImageUrl[i] ?'border-yellow':''}}" src="{{ item }}" />
                              </a>
                            </div>
                          </ng-container>
                        </div>
                      </div>

                    </lightgallery>
                  </div>


            <!-- <div class="row">
              <div class="col-9">
                img 1
              </div>
              <div class="col-3">
                <div class="row">
                  <div class="col-12">
                    img 2
                  </div>
                  <div class="col-12">
                    img 3
                  </div>
                  <div class="col-12">
                    img 4
                  </div>
                </div>
              </div>   
            </div> -->
    
          </div>

          <div class="col-lg-8 mb-3"  [style.opacity]="isLogin ? '1' : '0.1'">
            <div class="row">
              <div class="col-12 mb-2">
                <h3 class="cdc1 fw-bold" [innerHTML]='comparepage(draftProductdraftName,existingProductname)'></h3>
              </div>

              <div class="col-12">
                <div class="text-end cd-title cdbgthird mb-3">
                  <h2 class="mb-0 cdc1 fw-bold">
                    <font [innerHTML]="comparepage(draftCurrency,exsistingCurrency)+' '"></font> 
                    <font [innerHTML]="comparepage(draftProductdraftPrice,existingProductprice)"></font>
                  </h2>
                </div>
              </div>

              <div class="col-12 mb-2" *ngIf="companyData">

                                        <table class="mb-2 mb-sm-4">
                                          <tr>
                                              <td>
                                                <img  class="rounded-circle avatar" src="{{(companyData?.vendorLogo)?companyData?.vendorLogo:'/assets/images/default-company.jpeg'}}" style="width: 40px; height: 40px;">
                                                
                                              </td>
                                              <td>
                                                <!-- <strong class="ms-2 me-2">{{companyName}}</strong> -->

                                                <span *ngIf="companyData?.vendorName" class="ps-2 cdc1 fw-bold pointer" (click)="redirect()">
                                                  <!-- <img src="/assets/images/icons/vendor-icon.png" class="vendor-icon pe-1"> -->
                                                  <font class="limit-text">{{ companyData?.vendorName }}</font>
                                                </span>
                                                <span *ngIf="!companyData?.vendorName"
                                                  class="ms-2 badge rounded-pill cdbg1 text-white ncpname text-dark limit-text badge-limit"
                                                  >
                                                  <!-- <img src="/assets/images/icons/vendor-confidential.png" class="vendor-icon pe-1"> -->
                                                  <font class="limit-text">Confidential</font>
                                                </span>

                                                <br>
                                                <div *ngIf="companyData?.vendorName" class="vendorLoc ps-1">
                                                  <small class="cdc1"><i class="bi bi-geo-alt-fill" style="color:var(--primary-color)"></i> {{companyData?.vendorLocation}} &nbsp;&nbsp;
                                                    
                                                    <ng-container *ngIf="companyData?.isCompanySetPKP">
                                                      |&nbsp;&nbsp; Tax Status:  {{(companyData?.isPKP)?'PKP':'non-PKP'}}
                                                    </ng-container>
                                                  </small>
                                                </div>


                                              </td> 
                                              <td>
                                              <!-- <img src="/assets/images/icons/fluent_ribbon-star-24-filled@3x.png" class="img-fluid ratingiconsmall">
                                              <img src="/assets/images/icons/fluent_ribbon-star-24-filled@3x.png" class="img-fluid ratingiconsmall"> -->
                                              </td>
                                          </tr>
                                        </table>
    
                                        <div class="col-12 mt-3 pt-1 d-none">
                                            <div class="row text-center mb-3">
                                              <div class="col text-center">
                                                  <div class="boxratingtitle">Customer Satisfaction</div>
                                                  <div class="boxrating pt-4 pb-4">
                                                      <img src="/assets/images/icons/fluent_ribbon-star-24-filled@3x.png" class="img-fluid ratingiconsmall">
                                                      <img src="/assets/images/icons/fluent_ribbon-star-24-filled@3x.png" class="img-fluid ratingiconsmall">
                                                      <!-- <img src="/assets/images/icons/fluent_ribbon-star-24-filled@3x.png" class="img-fluid ratingicon">
                                                      <img src="/assets/images/icons/fluent_ribbon-star-24-filled@3x.png" class="img-fluid ratingicon">
                                                      <img src="/assets/images/icons/fluent_ribbon-star-24-filled@3x.png" class="img-fluid ratingicon"> -->
                                                  </div>
                                              </div>
                                              <div class="col text-center">
                                                      <div class="boxratingtitle">Product Rating</div>
                                                      <div class="boxrating pt-3 pb-3">
                                                          <h1 class="fw-bold fw-bold mb-1 mt-1 boxratingtext">4.8<img src="/assets/images/icons/rating-star.png" class="img-fluid starsmall"></h1>
                                                      </div>
                                              </div>
                                              <div class="col text-center">
                                                  <!-- <div class="boxratingtitle">Viewed Today</div>
                                                  <div class="boxrating pt-3 pb-3">
                                                      <h1 class="fw-bold fw-bold mb-1 mt-1">5<img src="/assets/images/icons/rating-down.png" class="img-fluid align-top pt-2"></h1>
                                                  </div> -->
                                              </div>
                                              <div class="col text-center">
                                                  <!-- <div class="boxratingtitle">Quoted Today</div>
                                                  <div class="boxrating pt-3 pb-3">
                                                      <h1 class="fw-bold fw-bold mb-1 mt-1">2<img src="/assets/images/icons/rating-up.png" class="img-fluid align-top pt-2"></h1>
                                                  </div> -->
                                              </div>
                                              <div class="col text-center">
                                                  <!-- <div class="boxratingtitle">On Auction Today</div>
                                                  <div class="boxrating pt-3 pb-3">
                                                      <h1 class="fw-bold fw-bold mb-1 mt-1">2<img src="/assets/images/icons/rating-up.png" class="img-fluid align-top pt-2"></h1>
                                                  </div> -->
                                              </div>
                                            </div>
                                        </div>
                                        

               
              </div>


              <div class="col-12 mb-2 d-none isHide" *ngIf="isPublic=='Y'">
                <div *ngIf="isPreviewShopFront=='N'">
                  <div class="text-end pt-3 pb-4" *ngIf="isLogin">
                    <a class="cart-btn mx-2" (click)="addToCart()">
                      <i class="bi bi-cart"></i>
                      Add to cart 
                    </a>

                    <a (click)="sendMessage()" class="ask-btn">
                      <img src="/assets/images/icons/qrfq-chat.jpg" class="ask-icon" /> Ask
                      Customer
                    </a>
                  </div>
                  <div class="text-end pt-3 pb-4" *ngIf="!isLogin">
                    <a class="cart-btn mx-2 disabled" style="cursor: not-allowed;">
                      <i class="bi bi-cart"></i>
                      Add to cart 
                    </a>

                    <a  class="ask-btn disabled" style="cursor: not-allowed;">
                      <img src="/assets/images/icons/qrfq-chat.jpg" class="ask-icon" /> Ask
                      Customer
                    </a>
                  </div>
                </div>
                <div *ngIf="isPreviewShopFront=='Y'">
                  <div class="text-end pt-3 pb-4">
                    <a class="cart-btn mx-2 disabled" style="cursor: not-allowed;">
                      <i class="bi bi-cart"></i>
                      Add to cart 
                    </a>

                    <a  class="ask-btn disabled" style="cursor: not-allowed;">
                      <img src="/assets/images/icons/qrfq-chat.jpg" class="ask-icon" /> Ask
                      Customer
                    </a>
                  </div>
                </div>
              </div>

 

              <div class="col-12 cd-rfq-product-quote" [hidden]="!isLogin">
                <div class="row">
                  <div class="col-lg-4">
                    <p class="mb-0">
                      <b>Merk Produk</b>
                    </p>
                    <p [innerHTML]='comparepage(draftProductdraftBrand,existingProductbrand)'></p>
                  </div>
                  <div class="col-lg-4">
                    <p class="mb-0">
                      <b>Kode Produk</b>
                    </p>
                    <p [innerHTML]='comparepage(draftProductdraftSku,existingProductsku)'></p>
                  </div>
                  <div class="col-lg-4">
                    <p class="mb-0">
                      <b>Nomor SKU</b>
                    </p>
                    
                    <p [innerHTML]='comparepage(draftProductdraftManufacturerSku,existingProductmanufacturerSku)'></p>
                  </div>
                </div>
              </div>


         

            </div>
          </div>




          <div class="col-12" [hidden]="!isLogin">

              <div class="cd-rfq-product-quote">
                <div class="row">
                  <div class="col-lg-12">
                    <p class="mb-0">
                      <b>Company Tag</b>
                    </p>


                              <div *ngIf="isTagsChanges">
                                <span class="badge rounded-pill bg-secondary me-1 bgtags  c1 badgetag"  *ngFor="let tags of SelectedTagsDraft; let i = index"><div class="highlight">{{ tags }}</div>
                                </span>
                              </div>

                              <div *ngIf="!isTagsChanges">
                                <span class="badge rounded-pill bg-secondary me-1 bgtags  c1 badgetag"  *ngFor="let tags of SelectedTagsExist; let i = index">{{ tags }}
                                </span>
                                <p class="mb-0" *ngIf="SelectedTagsExist.length==0">-</p>
                              </div>


                    <ng-container *ngIf="productData?.tags">
                      <p *ngIf="productData?.tags.length<1">-</p>
                      <div *ngIf="productData?.tags.length>0">
                        <span class="badge rounded-pill bg-secondary me-1 bgtags c1 badgetag" *ngFor="let tags of productData?.tags; let i = index">{{tags?.tag}}</span>
                      </div>
                    </ng-container>

                    <div class="pb-3"></div>
                  </div>
                  <div class="col-lg-12">
                    <p class="mb-0">
                      <b>Deskripsi Produk</b>
                    </p>
                    <div style="white-space: pre-line">
                      <div [innerHTML]="comparepage(desc1draft,desc1exist)"></div>
                    </div>
                    <div class="pb-3"></div>
                  </div>
                  <div class="col-lg-12">
                    <p class="mb-0">
                      <b>Label - Spesifikasi</b>
                    </p>
                    <div [innerHTML]="comparepagespec(desc2exist,desc2draft)"></div>
                    <div class="pb-3"></div>
                  </div>
                </div>
              </div>            
          </div>



          <div class="col-12">
            <div class="row">
              <div class="col-12 cd-rfq-product-quote" *ngIf="isPublic=='N'">
                <div class="row g-3">
                  <div class="col-lg-6">
                    <div class="cdbgthird p-2">
                      <p class="mb-0">
                        <b>Harga Minimal</b>
                      </p>

                      <p class="mb-0" *ngIf="draftProductdraftAutobidMinimumPrice">
                        <font [innerHTML]="comparepage(draftCurrency,exsistingCurrency)+' '"></font> 
                        <font [innerHTML]="comparepage(draftProductdraftAutobidMinimumPrice,existingProductautobidMinimumPrice)"></font>
                      </p>
                      <p class="mb-0" *ngIf="!draftProductdraftAutobidMinimumPrice">-</p>

                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="cdbgthird p-2">
                      <p class="mb-0">
                        <b>Kenaikan Diskon</b>
                      </p>
                      <p class="mb-0" *ngIf="draftProductdraftAutobidPriceDecrement">
                        <font [innerHTML]="comparepage(draftCurrency,exsistingCurrency)+' '"></font> 
                        <font [innerHTML]="comparepage(draftProductdraftAutobidPriceDecrement,existingProductautobidPriceDecrement)"></font>
                      </p>
                      <p class="mb-0" *ngIf="!draftProductdraftAutobidPriceDecrement">-</p>
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <div class="cdbgthird p-2">
                      <p class="mb-0">
                        <b>Tampilkan Harga</b>
                      </p>
                              <div *ngIf="draftProductdraftIsDisplayPriceOnShopfront!==null">
                                <span *ngIf='draftProductdraftIsDisplayPriceOnShopfront' class="badge rounded-pill ps-2 pe-2 pt-1 pb-1 bgenable"><div class="highlightbadge">Enable</div>
                                </span>
                                <span *ngIf='!draftProductdraftIsDisplayPriceOnShopfront' class="badge rounded-pill ps-2 pe-2 pt-1 pb-1 bgdisable"><div class="highlight">Disable</div>
                                </span>
                              </div>
                              <div *ngIf="draftProductdraftIsDisplayPriceOnShopfront==null">
                                
                                <span *ngIf='existingProductisDisplayPriceOnShopfront' class="badge rounded-pill ps-2 pe-2 pt-1 pb-1 bgenable">Enable
                                </span>
                                <span *ngIf='!existingProductisDisplayPriceOnShopfront' class="badge rounded-pill ps-2 pe-2 pt-1 pb-1 bgdisable">Disable
                                </span>
                              </div>                      

                    </div>

           
                  </div>
                  <div class="col-lg-4">

                    <div class="cdbgthird p-2">
                      <p class="mb-0">
                        <b>Tampilkan di Shopfront</b>
                      </p>
                            <div *ngIf="draftProductdraftIsDisplayProductOnShopfront!==null">
                              <span *ngIf='draftProductdraftIsDisplayProductOnShopfront' class="badge rounded-pill ps-2 pe-2 pt-1 pb-1 bgenable"><div class="highlightbadge">Enable</div>
                              </span>
                              <span *ngIf='!draftProductdraftIsDisplayProductOnShopfront' class="badge rounded-pill ps-2 pe-2 pt-1 pb-1 bgdisable"><div class="highlight">Disable</div>
                              </span>
                            </div>
                            <div *ngIf="draftProductdraftIsDisplayProductOnShopfront==null">
                              <span *ngIf='existingProductisDisplayProductOnShopfront' class="badge rounded-pill ps-2 pe-2 pt-1 pb-1 bgenable">Enable
                              </span>
                              <span *ngIf='!existingProductisDisplayProductOnShopfront' class="badge rounded-pill ps-2 pe-2 pt-1 pb-1 bgdisable">Disable
                              </span>
                            </div>        
                    </div>

                
                  </div>


                  <div class="col-lg-4">

                    <div class="cdbgthird p-2">
                      <p class="mb-0">
                        <b>Auto Bid</b>
                      </p>

                            <div *ngIf="draftProductdraftIsAutobidEnabled!==null">
                              <span *ngIf='draftProductdraftIsAutobidEnabled' class="badge rounded-pill ps-2 pe-2 pt-1 pb-1 bgenable"><div class="highlightbadge">Enable</div>
                              </span>
                              <span *ngIf='!draftProductdraftIsAutobidEnabled' class="badge rounded-pill ps-2 pe-2 pt-1 pb-1 bgdisable"><div class="highlight">Disable</div>
                              </span>
                            </div>
                            <div *ngIf="draftProductdraftIsAutobidEnabled==null">
                              
                              <span *ngIf='existingProductisAutobidEnabled' class="badge rounded-pill ps-2 pe-2 pt-1 pb-1 bgenable">Enable
                              </span>
                              <span *ngIf='!existingProductisAutobidEnabled' class="badge rounded-pill ps-2 pe-2 pt-1 pb-1 bgdisable">Disable
                              </span>
                            </div>
                    </div>


                  </div>
                </div>
              </div>
            </div>
          </div>


          <div class="col position-absolute" *ngIf="isPublic=='Y'">
            <div class="" [hidden]="isLogin">
              <div class="notif p-5 text-center">
                <div class="py-5">
                  <p><strong>Please register to contact this seller.</strong></p>
                  <a href="/login" class="btn btn-primary bg1 fhbtn1t me-2 pointer"
                    >Login</a
                  >
                  or
                  <a href="/regis" class="btn btn-primary bg1 fhbtn1 ms-2 pointer"
                    >Register</a
                  >
                </div>

              </div>
            </div>
          </div>


        </div>
      </div>
    </div>

  </div>


</div>